import { Paper, styled } from '@mui/material'

export const StyledPaper = styled(Paper)(() => ({
  width: '90%',
  maxWidth: '1440px',
  overflow: 'hidden',
  borderRadius: '8px',
}))
